import { render } from "./NumberOne.vue?vue&type=template&id=5e72e24b"
import script from "./NumberOne.vue?vue&type=script&lang=js"
export * from "./NumberOne.vue?vue&type=script&lang=js"

import "./NumberOne.vue?vue&type=style&index=0&id=5e72e24b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__